import React, { useEffect, useState, useCallback } from 'react';
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import fakeDataCookingReg from './fake-data-cooking-register';
import dayjs from 'dayjs';

import * as cuisineOrderManagementAction from "../../../../redux/store-sarang/cuisine-order/cuisine-order-management.store";
import LoadingViewAria from '../../../../components/layout-sarang/loading-view-aria'
import Select from "react-select";
import * as branchManagementAction from "../../../../redux/store-sarang/branch/branch-management.store";
import * as accountManagementAction from "../../../../redux/store/account/account.store";

export default function CookingRegisterChart(props) {
    const { listMonth } = props;
    //const data = [...fakeDataCookingReg];
    const [data, setData] = useState([...fakeDataCookingReg]);
    const [options, setOptions] = useState([...fakeDataCookingReg]);
    const [loading, setLoading] = useState(false);
    const [month, setMonth] = useState(new Date().getMonth() + 1);
    const [year, setYear] = useState(new Date().getFullYear());
    const [branch, setBranch] = useState([]);
    const [currentBranchId, setCurrentBranchId] = useState(null);

    const getSumaryByDateCuisineOrder = useCallback(async (getYear = undefined, getMonth = undefined, getBranchId = undefined) => {
        getYear = getYear ? getYear : year;
        getMonth = getMonth ? getMonth : month;
        getBranchId = getBranchId !== undefined ? getBranchId : currentBranchId;

        let fromDate = new Date(getYear + "-" + getMonth + "-1");
        let toDate = new Date(getYear + "-" + getMonth + "-1");
        toDate = new Date(new Date(toDate.setMonth(getMonth)).setDate(0));  //tháng sau

        setLoading(true);
        try {
            const res = await cuisineOrderManagementAction.SumaryByDateCuisineOrder(dayjs(fromDate).format(), dayjs(toDate).format(), getBranchId);

            if (res && res.content) {
                setData(res.content);
                setOptions(
                    {
                        chart: {
                            type: 'column',
                        },
                        title: {
                            text: 'Đăng ký suất ăn',
                        },
                        xAxis: {
                            categories: res.content.map((entry) => dayjs(entry.orderDate).format("DD/MM/YYYY")),
                        },
                        yAxis: {
                            title: {
                                text: 'Số suất ăn',
                            },
                            stackLabels: {
                                enabled: true
                            }
                        },
                        plotOptions: {
                            column: {
                                stacking: 'normal',
                                dataLabels: {
                                    enabled: true
                                }
                            }
                        },
                        series: [{
                            name: 'Nam (trưa)',
                            data: res.content.map((entry) => entry.manNumberMealSetLunch)
                        },
                        {
                            name: 'Nữ (trưa)',
                            data: res.content.map((entry) => entry.womanNumberMealSetLunch)
                        },
                        {
                            name: 'Nam (chiều)',
                            data: res.content.map((entry) => entry.manNumberMealSetDinner)
                        },
                        {
                            name: 'Nữ (chiều)',
                            data: res.content.map((entry) => entry.womanNumberMealSetDinner)
                        },
                        {
                            name: 'Ăn tại NH (trưa)',
                            data: res.content.map((entry) => entry.eatAtRestaurantLunch)
                        },
                        {
                            name: 'Ăn tại NH (chiều)',
                            data: res.content.map((entry) => entry.eatAtRestaurantDinner)
                        }]
                    }
                );
            }

        } catch (err) {
            if (err && err.errorType) {
                //ShowNotification(
                //    viVN.Errors[err.errorType],
                //    NotificationMessageType.Error
                //);
            }
        } finally {
            setLoading(false);
        }
    }, [year, month, currentBranchId]);

    useEffect(() => {
        const init = async () => {
            try {
                const resB = await branchManagementAction.GetLookupBranch();
                if (resB && resB.content) {
                    setBranch(resB.content);
                }

                const resU = await accountManagementAction.GetDetailAcc();
                let branchId = null;
                if (resU && resU.content) {
                    branchId = resU.content.branchId;
                    if (branchId) {
                        setCurrentBranchId(branchId);
                    }
                }
                getSumaryByDateCuisineOrder(year, month, branchId);
            } catch (err) {
                getSumaryByDateCuisineOrder();
            }
        };

        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onChangeMonth = (event = undefined) => {
        let eventMonth = month;
        let eventYear = year;
        let eventBranchId = currentBranchId;
        if (event?.target?.name === "month") {
            eventMonth = event.target.value;
            setMonth(event.target.value);
        }
        else if (event?.target?.name === "year") {
            eventYear = event.target.value;
            setYear(event.target.value);
        }
        getSumaryByDateCuisineOrder(eventYear, eventMonth, eventBranchId);
    }

    return options ?
        <div className="card">
            <div className="card-header d-flex align-items-center">
                <div className="row">
                    <div className="col-7" style={{ paddingRight: "0px" }}>
                        <select className="form-control form-control-sm" name="month" placeholder="Tháng" style={{ width: "100px" }} onChange={(e) => onChangeMonth(e)} defaultValue={month}>
                            {
                                listMonth && listMonth.length > 0 && listMonth.map((item) => <option value={item}>Tháng {item}</option>)
                            }
                        </select>
                    </div>
                    <div className="col-5" style={{ paddingRight: "0px", paddingLeft: "0px" }}>
                        <select className="form-control form-control-sm" name="year" placeholder="Năm" onChange={(e) => onChangeMonth(e)} defaultValue={year}>
                            <option value="2024">2024</option>
                            <option value="2025">2025</option>
                            <option value="2026">2026</option>
                        </select>
                    </div>
                </div>
                <div className="ml-auto d-flex align-items-center">
                    <div style={{ width: '200px' }}>
                        <Select
                            isClearable
                            value={branch?.map(item => ({ label: item.name, value: item.id })).find(x => x.value === currentBranchId) || null}
                            onChange={(data) => {
                                const bid = data ? data.value : null;
                                setCurrentBranchId(bid);
                                getSumaryByDateCuisineOrder(year, month, bid);
                            }}
                            placeholder="Chọn Chi hội"
                            options={branch?.map(item => ({ label: item.name, value: item.id }))}
                            noOptionsMessage={() => "Không tồn tại"}
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                        />
                    </div>
                    <div className="dropdown ml-2">
                        <a className="toolbar" href="#" onClick={(e) => {
                            e.preventDefault();
                            onChangeMonth();
                        }} role="button" aria-haspopup="true" aria-expanded="false"><i title="Làm mới" className=" fas fa-history"></i> </a>
                    </div>
                </div>
            </div>
            <div className="card-body">
                <HighchartsReact highcharts={Highcharts} options={options} />
            </div>
            <LoadingViewAria loading={loading} />
        </div>
        : <></>;
}